var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"person-avatar avatar"},[(_vm.pessoa.photo)?_c('img',{attrs:{"src":_vm.pessoa.photo}}):_c('div',{staticClass:"img-fake"},[_vm._v(_vm._s(_vm.firstLettersName(_vm.pessoa.name)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }